<div class="hmn-shared-profile-circle hmn-row__center">
  <p class="hmn-color__primary">MC</p>
</div>
